import { render, staticRenderFns } from "./documento.vue?vue&type=template&id=e69b10d0&scoped=true"
import script from "./documento.ts?vue&type=script&lang=ts&external"
export * from "./documento.ts?vue&type=script&lang=ts&external"
import style0 from "./documento.vue?vue&type=style&index=0&id=e69b10d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e69b10d0",
  null
  
)

export default component.exports